import {
  Component,
  ViewEncapsulation,
  ViewChild,
  HostListener,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'app-fullscreen',
  encapsulation: ViewEncapsulation.None,
  template: `
    <button mat-icon-button class="full-screen h-100 w-100 d-inline-block full_screen_icon l-0 c-white">
        <mat-icon class="m-0 c-gray-98" *ngIf="!toggle" #expand>fullscreen</mat-icon>
        <mat-icon class="m-0 c-gray-98" *ngIf="toggle" #compress>fullscreen_exit</mat-icon>
    </button>
  `,
  styles: [`full-screen {position: absolute; top: -10px;}
  .full_screen_icon span.mat-button-wrapper
  {
    display: inline-block!important;
    height: 40px!important;
    vertical-align:middle;
  }
  .full_screen_icon span.mat-button-wrapper mat-icon
  {
    font-size: 40px;
  }
  `]
})
export class FullScreenComponent {
  toggle: boolean = false;
  @ViewChild('expand') private expand: ElementRef;
  @ViewChild('compress') private compress: ElementRef;

  requestFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else {
      console.log('Fullscreen API is not supported.');
    }
  }

  exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else {
      console.log('Fullscreen API is not supported.');
    }
  }

  @HostListener('click')
  getFullscreen() {
    if (this.expand) {
      this.requestFullscreen(document.documentElement);
    }
    if (this.compress) {
      this.exitFullscreen();
    }
  }

  @HostListener('window:resize')
  onFullScreenChange() {
    const fullscreenElement =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement;
    if (fullscreenElement != null) {
      this.toggle = true;
    } else {
      this.toggle = false;
    }
  }
}
